import type { IconData } from '@stacksjs/iconify-core'

export const branch: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 18a1 1 0 1 0 0-2a1 1 0 0 0 0 2m1-7.002v3.173a3.001 3.001 0 1 1-2 0V5.829a3.001 3.001 0 1 1 2 0v2.34c.312-.11.647-.17.997-.171l6.037-.006a1 1 0 0 0 .999-1V5.84A3.001 3.001 0 0 1 13 0a3 3 0 0 1 1.033 5.817v1.175a3 3 0 0 1-2.997 3l-6.037.006a1 1 0 0 0-.999 1M3 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default branch
